var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"key-unit"},[_c('p',{staticClass:"key-unit-key"},[_vm._v(_vm._s(_vm.title)+"：")]),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }